import React from 'react';
import { useTheme } from '../hooks/useTheme';
import '../styles/components/ThemeToggle.css';

const ThemeToggle = ({ className, isDarkVariant = false }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <div
      className={`theme-toggle ${className ?? ''} ${
        isDarkVariant && !isDarkMode ? 'tht-dark' : ''
      }`}
    >
      <div>
        <input
          id='btn'
          type='checkbox'
          className='theme-toggle__checkbox'
          onChange={toggleTheme}
          checked={isDarkMode}
        />
        <label htmlFor='btn' className='theme-toggle__label' />
      </div>
      <span className=''>
        Turn {isDarkMode ? 'on' : 'off'} the{' '}
        <span className='font-secondary'>lights</span>
      </span>
    </div>
  );
};

export default ThemeToggle;
